import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { PATH_HOME, PATH_SUB_PAGE_TERMS, PATH_SUB_PAGE_PRIVACY, PATH_SUB_PAGE_FAQ } from '../../system/constants';
import { BASE_URL, HOMEPAGE_ABOUT, HOMEPAGE_CONTACT, HOMEPAGE_FAQ } from '../../common/constants';

import {} from '../../system/constants';
// import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getCopyrightText } from '../../common/textHelper';

import AfitdLink from '../../common/elemental/AfitdLink';
import AfitdTypography from '../../common/elemental/AfitdTypography';

// import _get from 'lodash/get';
// import _reduce from 'lodash/reduce';

const useStyles = makeStyles(theme => ({
    root: {
        // width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        // alignItems: 'center',
        // border: '1px red solid',
        marginBottom: 24,

        // added below lines
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 0,
            paddingTop: 5,
        },
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            marginBottom: 10,
            paddingTop: 0,
        },
    },
    footerLinks: {
        display: 'flex',
        justifyContent: 'center',
        // border: '1px green solid',
    },
    footerText: {
        // border: '1px red solid',
        fontSize: '13px',
        color: 'rgba(17, 30, 20, 0.4)',
    },
    separator: {
        fontSize: '13px',
        color: 'rgba(17, 30, 20, 0.4)',
        margin: '0 3px',
    },
    copyright: {
        textAlign: 'center',
        color: 'rgba(17, 30, 20, 0.4)',
        margin: '12px 0',
        [theme.breakpoints.down('md')]: { marginTop: 0, marginBottom: 16 },
    },
}));

const getDefns = params => {
    const { classes, history } = params;

    const defns = {
        copyright: {
            variant: 'caption',
        },
        aboutLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_ABOUT}`),
        },
        contactUsLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_CONTACT}`),
        },
        FAQLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_FAQ}`),
        },
        termsOfUseLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_TERMS}`),
        },
        privacyLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_PRIVACY}`),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickButton = (history, path) => {
    history.push(`${BASE_URL}${path}`);
};

const Footer = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    // const appContext = useContext(AppContext);
    // const context = useContext(LayoutContext);
    const classes = useStyles();
    const history = useHistory();

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, classes, history });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.footerLinks}>
                <AfitdLink {...defns.footerText}>
                    <span {...defns.aboutLink}>About Us</span>
                </AfitdLink>
                <div {...defns.separator}> / </div>
                <AfitdLink {...defns.footerText}>
                    <span {...defns.termsOfUseLink}>Terms</span>
                </AfitdLink>
                <div {...defns.separator}> / </div>
                <AfitdLink {...defns.footerText}>
                    <span {...defns.privacyLink}>Privacy</span>
                </AfitdLink>
                <div {...defns.separator}> / </div>
                <AfitdLink {...defns.footerText}>
                    <span {...defns.contactUsLink}>Contact Us</span>
                </AfitdLink>
            </div>
            <AfitdTypography {...defns.copyright}>{getCopyrightText({ variant: 'small' })}</AfitdTypography>
        </div>
    );
};

export default Footer;
